import { render, staticRenderFns } from "./ProjectsFilter.vue?vue&type=template&id=2c8878e0&scoped=true"
import script from "./projectsFilter.ts?vue&type=script&lang=ts&external"
export * from "./projectsFilter.ts?vue&type=script&lang=ts&external"
import style0 from "./ProjectsFilter.vue?vue&type=style&index=0&id=2c8878e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8878e0",
  null
  
)

export default component.exports